import { parseISO, isAfter, isBefore, endOfDay, isValid, startOfDay } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';
import { isTreatmentWithConfig, type Treatments } from 'utils/treatments';

type LimitedTimePremiumPlusConfig = {
  start: string;
  end: string;
};

const computeLimitedTimePremiumPlusEligibility = (
  limitedTimePremiumPlusConfig: LimitedTimePremiumPlusConfig | null | undefined,
  userTimeZone: string = 'America/Los_Angeles',
): boolean => {
  if (
    !limitedTimePremiumPlusConfig ||
    !limitedTimePremiumPlusConfig.start ||
    !limitedTimePremiumPlusConfig.end
  ) {
    return false;
  }

  const { start, end } = limitedTimePremiumPlusConfig;
  const startDate = startOfDay(parseISO(start));
  const endDate = endOfDay(parseISO(end));

  if (!isValid(startDate) || !isValid(endDate)) {
    return false;
  }

  const currentDate = new Date();
  const currentDateInUserTZ = toZonedTime(currentDate, userTimeZone);
  const startDateInUserTZ = toZonedTime(startDate, userTimeZone);
  const endDateInUserTZ = toZonedTime(endDate, userTimeZone);

  return (
    isAfter(currentDateInUserTZ, startDateInUserTZ) &&
    isBefore(currentDateInUserTZ, endDateInUserTZ)
  );
};

/**
 * Determines if the LimitedTimeOfferBanner should be shown.
 * Banner is only shown when the treatment is 'on' (not 'on_no_banner').
 */
export const shouldShowLimitedTimeOfferBanner = (
  isEligible: boolean,
  treatments: Treatments,
  treatmentKey: string,
): boolean => {
  if (!isEligible) return false;

  const treatment = treatments?.[treatmentKey];
  if (!treatment) return false;

  if (isTreatmentWithConfig(treatment)) {
    return treatment.treatment === 'on';
  }

  return treatment === 'on';
};

export default computeLimitedTimePremiumPlusEligibility;
